import { AuditActionTypes } from './audit.types'

//New Audit
export const newAuditRequest = data => ({
    type: AuditActionTypes.NEW_AUDIT_REQUEST,
    payload: data
})

export const newAuditRequestSuccess = data => ({
    type: AuditActionTypes.NEW_AUDIT_REQUEST_SUCCESS,
    payload: data
})

export const newAuditRequestError = data => ({
    type: AuditActionTypes.NEW_AUDIT_REQUEST_ERROR,
    payload: data
})

export const newAuditRequestStatus = data => ({
    type: AuditActionTypes.NEW_AUDIT_REQUEST_STATUS,
    payload: data
})

//Audit List
export const auditListRequest = data => ({
    type: AuditActionTypes.AUDIT_LIST_REQUEST,
    payload: data
})

export const auditListRequestSuccess = data => ({
    type: AuditActionTypes.AUDIT_LIST_REQUEST_SUCCESS,
    payload: data
})

export const auditListRequestError = data => ({
    type: AuditActionTypes.AUDIT_LIST_REQUEST_ERROR,
    payload: data
})

//Audit Detail
export const auditDetailRequest = data => ({
    type: AuditActionTypes.AUDIT_DETAIL_REQUEST,
    payload: data
})

export const auditDetailRequestSuccess = data => ({
    type: AuditActionTypes.AUDIT_DETAIL_REQUEST_SUCCESS,
    payload: data
})

export const auditDetailRequestError = data => ({
    type: AuditActionTypes.AUDIT_DETAIL_REQUEST_ERROR,
    payload: data
})

//Audit Assign User
export const auditAssignUserRequest = data => ({
    type: AuditActionTypes.AUDIT_ASSIGN_USER_REQUEST,
    payload: data
})

export const auditAssignUserRequestSuccess = data => ({
    type: AuditActionTypes.AUDIT_ASSIGN_USER_REQUEST_SUCCESS,
    payload: data
})

export const auditAssignUserRequestError = data => ({
    type: AuditActionTypes.AUDIT_ASSIGN_USER_REQUEST_ERROR,
    payload: data
})

export const auditAssignUserRequestStatus = data => ({
    type: AuditActionTypes.AUDIT_ASSIGN_USER_REQUEST_STATUS,
    payload: data
})

//Audit Update Status
export const auditUpdateStatusRequest = data => ({
    type: AuditActionTypes.AUDIT_UPDATE_STATUS_REQUEST,
    payload: data
})

export const auditUpdateStatusRequestSuccess = data => ({
    type: AuditActionTypes.AUDIT_UPDATE_STATUS_REQUEST_SUCCESS,
    payload: data
})

export const auditUpdateStatusRequestError = data => ({
    type: AuditActionTypes.AUDIT_UPDATE_STATUS_REQUEST_ERROR,
    payload: data
})

export const auditUpdateStatusRequestStatus = data => ({
    type: AuditActionTypes.AUDIT_UPDATE_STATUS_REQUEST_STATUS,
    payload: data
})

//Audit Add log
export const auditAddLogRequest = data => ({
    type: AuditActionTypes.AUDIT_ADD_LOG_REQUEST,
    payload: data
})

export const auditAddLogRequestSuccess = data => ({
    type: AuditActionTypes.AUDIT_ADD_LOG_REQUEST_SUCCESS,
    payload: data
})

export const auditAddLogRequestError = data => ({
    type: AuditActionTypes.AUDIT_ADD_LOG_REQUEST_ERROR,
    payload: data
})

export const auditAddLogRequestStatus = data => ({
    type: AuditActionTypes.AUDIT_ADD_LOG_REQUEST_STATUS,
    payload: data
})

//Update Log status
export const auditUpdateLogStatusRequest = data => ({
    type: AuditActionTypes.AUDIT_UPDATE_LOG_STATUS_REQUEST,
    payload: data
})

export const auditUpdateLogStatusRequestSuccess = data => ({
    type: AuditActionTypes.AUDIT_UPDATE_LOG_STATUS_REQUEST_SUCCESS,
    payload: data
})

export const auditUpdateLogStatusRequestError = data => ({
    type: AuditActionTypes.AUDIT_UPDATE_LOG_STATUS_REQUEST_ERROR,
    payload: data
})

export const auditUpdateLogStatusRequestStatus = data => ({
    type: AuditActionTypes.AUDIT_UPDATE_LOG_STATUS_REQUEST_STATUS,
    payload: data
})

//Audit Log add comment
export const auditAddLogCommentRequest = data => ({
    type: AuditActionTypes.AUDIT_ADD_LOG_COMMENT_REQUEST,
    payload: data
})

export const auditAddLogCommentRequestSuccess = data => ({
    type: AuditActionTypes.AUDIT_ADD_LOG_COMMENT_REQUEST_SUCCESS,
    payload: data
})

export const auditAddLogCommentRequestError = data => ({
    type: AuditActionTypes.AUDIT_ADD_LOG_COMMENT_REQUEST_ERROR,
    payload: data
})

export const auditAddLogCommentRequestStatus = data => ({
    type: AuditActionTypes.AUDIT_ADD_LOG_COMMENT_REQUEST_STATUS,
    payload: data
})